import React, {useEffect} from "react";
import {connect} from "react-redux";
import {Button, Card, Col, Container, Row} from "react-bootstrap";
import Radium, {StyleRoot} from "radium";
import {bounceIn} from "react-animations";
import {push} from "connected-react-router";
import i18n from "../../i18nextInitiator";
import getStatusText from "../../GetStatusText";

const t = i18n.getFixedT('fa','invoiceTrack');

/**
 * Animation Styles.
 * @type {{wobbie: {animationName: {__radiumKeyframes: boolean, __process: function(*=): {animationName: string, css: string}}, width: string, animation: string}}}
 */
const styles = {
    wobbie: {
        width: '100px',
        animation: 'x 1s',
        animationName: Radium.keyframes(bounceIn, 'bounceIn')
    }
}

const mapStateToProps = state => ({ ...state });
const mapDispatchToProps = dispatch => ({
    goToInvoice: id => dispatch(push(`/invoice/${id}/tracking`)),
    goToWorkerServices: ()=> dispatch(push(`/services/workers`))
});

const AfterSubmit = (props) => {

    return(
        <Container>
            <Row className='justify-content-center' style={{marginTop: 20}}>
                <Col sm={12} xs={12} md={10} lg={8} style={{ marginBottom: 100}} className='text-center'>
                    <Card>
                        <Card.Body>
                            <div className='text-center submitted-texts'>
                                <div style={{marginBottom: "50px"}}>
                                    <StyleRoot>
                                        <img style={styles.wobbie} src={`${process.env.PUBLIC_URL}/orders/images/success-icon.svg`} alt={props.name} />
                                    </StyleRoot>
                                    <h4 className="text-success" style={{fontSize:16}}>{t('afterSubmit.success-message')}</h4>
                                </div>
                                <h5 style={{fontSize:14}} >{t('afterSubmit.status-title')}</h5>
                                <h5 style={{color: "rgb(0, 76, 155)", fontSize:16}}>
                                    {getStatusText(props.order.bill && props.order.bill.order.status)}</h5>
                                <Button onClick={()=>props.goToInvoice(props.order.id)} variant={"success"} size={"lg"}>{t("afterSubmit.see-details")}</Button>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card onClick={props.goToWorkerServices} style={{backgroundColor:"#fff1cf", border:"none"}}>
                        <Card.Body style={{display:"flex"}}>
                            <img style={{float: "right"}} src={`${process.env.PUBLIC_URL}/orders/images/tech_service.svg`}/>
                            <p className="worker-services-banner">{t('afterSubmit.worker-services')}</p>
                            <img style={{color:"rgb(0, 76, 155)"}} src={`${process.env.PUBLIC_URL}/orders/images/icons/arrow-left-icon.svg`}/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AfterSubmit);